import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/uptime/uptime.query.gql"
import type {
  UptimeQuery,
  UptimeQueryVariables,
} from "@/v2-backoffice-client/uptime/__types__/uptime.query"

type Options = QueryHookOptions<UptimeQuery, UptimeQueryVariables>

export function useUptimeQuery(options?: Options) {
  return useQuery<UptimeQuery, UptimeQueryVariables>(query, options)
}
